import type {BioIconProps} from '../common-types'

export function ArrowIcon({fill = 'white', ...attributes}: BioIconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M11.6667 4.16602L17.5 9.99935M17.5 9.99935L11.6667 15.8327M17.5 9.99935H2.5"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
